$(document).ready(function(){
    const swiper = new Swiper('.hb_outer', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination',
      }
    });
});